module.exports = {"532924101":"金牛镇","532924102":"宾居镇","532924103":"州城镇","532924104":"大营镇","532924105":"鸡足山镇","532924106":"力角镇","532924107":"平川镇","532924108":"乔甸镇","532924201":"钟英傈僳族彝族乡","532924202":"拉乌彝族乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/532924.json
// module id = 2651
// module chunks = 0